import PropTypes from 'prop-types';
import { XIcon, CheckCircleIcon, WarningIcon, InfoIcon } from '@phosphor-icons/react';

const Alert = ({
  variant = 'info',
  header,
  onClose,
  children,
  textColor = 'text-neutral-110 dark:text-white'
}) => {
  const icons = {
    info: <InfoIcon size={16} color='#438BF7' />,
    warning: <WarningIcon size={16} color='#FFA940' />,
    alert: <WarningIcon size={16} color='#D71D10' />,
    success: <CheckCircleIcon size={16} color='#01B876' />
  };

  const variantStyles = {
    info: { backgroundColor: 'bg-info', borderColor: 'border-info' },
    warning: { backgroundColor: 'bg-warning', borderColor: 'border-warning' },
    alert: { backgroundColor: 'bg-alert', borderColor: 'border-alert' },
    success: { backgroundColor: 'bg-success', borderColor: 'border-success' }
  };

  const style = variantStyles[variant];

  return (
    <div className={`w-full px-4 py-3.5 ${style.backgroundColor} bg-opacity-5 rounded-md border ${style.borderColor} flex items-center justify-between`}>
      <div className='justify-start items-center gap-4 flex'>
        {icons[variant]}
        <div className={`${textColor}  text-sm font-normal leading-5`}>{header}</div>
      </div>
      {!!onClose
        && <XIcon size={16} color='black' style={{ cursor: 'pointer' }} onClick={onClose} />
      }
      {children}
    </div>
  );
};

Alert.propTypes = {
  variant: PropTypes.oneOf(['info', 'warning', 'alert', 'success']),
  header: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.node
};

export default Alert;
